@for (item of items; track $index) {
  <a class="spirit-link" [routerLink]="item.route" [queryParams]="item.queryParams" [skyTooltip]="item.label" [attr.aria-label]="item.label">
    @if (item.imageUrl) {
      <img [src]="item.imageUrl">
    } @else {
      <span>{{ item.label }}</span>
    }
  </a>
}
